/**
 * 背景音乐单例播放器
 * - 进入活动页/照片墙时随机播放一首并循环
 * - 跨页面保持播放不中断，离开活动相关页面自动停止
 * - 通过 onStateChange 订阅状态变化供 UI 刷新
 */
const TRACKS = [
  { name: '传奇', url: '/music/music-1.mp3' },
  { name: '乌兰巴托的夜', url: '/music/music-2.mp3' },
  { name: 'Summer Rider 1969', url: '/music/music-3.mp3' },
  { name: 'Letter from Rosie', url: '/music/music-4.mp3' }
]

let audio = null
let currentIndex = -1
let listeners = []

function ensureAudio() {
  if (!audio) {
    audio = new Audio()
    audio.loop = true
    audio.preload = 'auto'
  }
  return audio
}

function emit() {
  listeners.forEach((cb) => {
    try { cb() } catch (e) { /* 忽略 UI 回调异常 */ }
  })
}

/** 随机播放一首（避免连续同一首），返回是否成功开始 */
export function playRandom() {
  if (!TRACKS.length) return false
  const a = ensureAudio()
  let idx
  do {
    idx = Math.floor(Math.random() * TRACKS.length)
  } while (idx === currentIndex && TRACKS.length > 1)
  currentIndex = idx
  a.src = TRACKS[idx].url
  const p = a.play()
  if (p && p.catch) {
    // 浏览器自动播放策略拦截时静默失败，UI 按钮可兜底
    p.catch(() => {})
  }
  emit()
  return true
}

/** 暂停/继续（未初始化时直接随机开始） */
export function toggle() {
  const a = audio
  if (!a || a.paused) {
    if (!a) { playRandom(); return }
    a.play().catch(() => {})
  } else {
    a.pause()
  }
  emit()
}

/** 切下一首（随机） */
export function next() {
  playRandom()
}

/** 停止并释放 */
export function stop() {
  if (audio) {
    audio.pause()
    audio.removeAttribute('src')
    audio.load()
  }
  currentIndex = -1
  emit()
}

export function isPlaying() {
  return audio ? !audio.paused : false
}

export function currentTrack() {
  return currentIndex >= 0 ? TRACKS[currentIndex] : null
}

export function onStateChange(cb) {
  listeners.push(cb)
  return () => {
    listeners = listeners.filter((l) => l !== cb)
  }
}
